import { inject, Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { ObjectIconsService } from './object-icons.service';

@Pipe({
  standalone: true,
  name: 'objectIcon',
  pure: false,
})
export class ObjectIconPipe implements PipeTransform {
  private readonly objectIconsService = inject(ObjectIconsService);

  transform(id: number, accountId?: number | null): SafeHtml {
    return this.objectIconsService.getObjectIcon(id, accountId);
  }
}
